var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['iconBtn', _vm.customClass],attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.onClick}},[(_vm.iconAttrs)?_c('svg-sprite',_vm._b({},'svg-sprite',_vm.iconAttrs,false)):_vm._e(),(_vm.shouldDisplayCounter)?_c('span',{staticClass:"counter"},[_vm._v(_vm._s(_vm.counter))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }